<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="500" transition="dialog-bottom-transition" persistent>
      <v-card>
        <v-card-title class="text-h5 blue darken-4 white--text">
          Cambiar estado del proyecto
          <v-spacer></v-spacer>
          <v-icon dark right @click="dialog = !dialog" :disabled="loading">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <p class="text-center h4">{{ xprograma.programa }}</p>
          <v-row>
            <v-col class="text-right">
              <v-btn color="green" class="darken-2 white--text" tile @click="enviar(2)" :disabled="loading">
                <v-icon small left>
                  mdi-check
                </v-icon>
                Aprobado
              </v-btn>
            </v-col>
            <v-col>
              <v-btn color="red" class="darken-4 white--text" tile @click="enviar(3)" :disabled="loading">
                <v-icon small left>
                  mdi-cancel
                </v-icon>
                Rechazado
              </v-btn>
            </v-col>
          </v-row>

          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear v-if="loading" indeterminate color="indigo"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      programa_id: null,
      xprograma: {
        programa: null,
      },
      msg: '',
    }),
    methods: {
      openmodal(editar) {
        window.console.log(editar);
        this.msg = '';
        this.dialog = true;
        for (let name in this.xprograma) {
          this.xprograma[name] = null;
        }
        if (editar) {
          this.programa_id = editar.id;
          this.xprograma.programa = editar.programa;
        }
      },
      enviar(xestado) {
        this.loading = true;
        this.msg = '';
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx/estadoprograma`;
        //const url = `http://localhost:8090/api/v1/programa-unsxx/estadoprograma`;
        window.console.log(url);
        let data = {
          estado_programa: xestado,
          id: this.programa_id,
        };
        xaxios
          .post(url, data)
          .then((res) => {
            vue.msg = res.data;
            vue.loading = false;
            vue.$emit('xnewestado', res.data);
            vue.dialog = false;
          })
          .catch((error) => {
            window.console.error(error);
            vue.msg = error;
            vue.loading = false;
          });
      },
    },
    mounted() {},
  };
</script>
